import { useState, useEffect } from "react";

export default function PhotoUploader({ inputClass, file, setFile, telegramId, setServerUrl }) {
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (typeof file === "string" && file.startsWith("https")) {
      setPreview(file);
    } else if (file instanceof File) {
      setPreview(URL.createObjectURL(file));
    } else {
      setPreview(null);
    }
  }, [file]);

  const handleFileChange = async (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    setPreview(URL.createObjectURL(selectedFile)); // локальное превью
    setLoading(true);

    try {
      if (!telegramId) {
        alert("Идентификатор пользователя не определён. Попробуйте позже.");
        setLoading(false);
        return;
      }

      const formData = new FormData();
      formData.append("file", selectedFile);
      formData.append("user_id", telegramId);

      const res = await fetch("https://botiambtl.ru/api/upload_photo/", {
        method: "POST",
        body: formData,
      });

      const data = await res.json();

      if (!res.ok) {
        console.error("Ошибка загрузки фото:", data);
        alert("❌ Ошибка при загрузке фото");
        setFile(null);
        setPreview(null);
        setServerUrl(null);
        return;
      }

      // ✅ Сохраняем blob для превью и serverUrl для отправки в App
      setFile(data.url);
      setServerUrl(data.url);

    } catch (err) {
      console.error("Network error:", err);
      alert("❌ Ошибка сети при загрузке фото");
      setFile(null);
      setPreview(null);
      setServerUrl(null);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col w-full mb-4">
      <div
        className={`relative w-full h-40 border rounded flex items-center justify-center cursor-pointer overflow-hidden
        ${inputClass} ${preview ? "p-0" : "p-2"}
        focus-within:ring-2 focus-within:ring-blue-500`}
      >
        {preview ? (
          <img
            src={preview}
            alt="preview"
            className="object-cover w-full h-full"
          />
        ) : (
          <span className="text-gray-400">
            {loading ? "Загрузка..." : "Нажмите, чтобы выбрать файл"}
          </span>
        )}
        <input
          type="file"
          accept="image/*"
          className="absolute w-full h-full opacity-0 box-border cursor-pointer"
          onChange={handleFileChange}
          disabled={loading || !telegramId}
        />
      </div>
    </div>
  );
}
